import { DownloadMobileGatewayModal } from './DownloadMobileGatewayModal';

export default DownloadMobileGatewayModal;
